import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import render from '@tk/utilities/tk.render';

type ValidEvent = keyof HTMLElementEventMap | TKCustomEventMap;

export default class TCSubmitDirect extends TKCustomElementFactory {
    attr?: string;
    requestURL?: string;
    eventHandler: ValidEvent;
    forceReload: boolean;
    noInitSubmit: boolean;
    reloadSummary: boolean;
    summaryContainer?: HTMLElement;
    summeryURL?: string;
    isInit: boolean;
    reloadAfterSubmit: boolean;
    changeTimeout?: ReturnType<typeof setTimeout> | undefined;

    constructor() {
        super();

        this.attr = this.getAttribute('data-tk-attr') || undefined;
        this.requestURL = this.getAttribute('data-tk-url') || undefined;
        this.eventHandler = (this.getAttribute('data-tk-eventhandler') as ValidEvent) || 'blur';
        this.forceReload = this.hasAttribute('data-tk-force-reload');
        this.noInitSubmit = this.hasAttribute('data-tk-no-init-submit');
        this.reloadSummary = this.hasAttribute('data-tk-reload-summary');
        this.reloadAfterSubmit = this.hasAttribute('data-tk-reload-after-submit');
        this.summaryContainer = document.querySelector('[data-tk-summary-container]') || undefined;
        this.summeryURL = this.summaryContainer?.getAttribute('data-tk-url') || undefined;
        this.isInit = true;
    }

    connectedCallback(): void {
        if (!this.requestURL) return;

        this.registerListener();
    }

    registerListener():void {
        const formField = this.querySelector('select') || this.querySelector('input')
        || this.querySelector('textarea') || undefined;

        if (formField) {
            const action = this.submitField.bind(this, formField, false);
            this.pushListener({
                event: this.eventHandler,
                element: formField,
                action
            });
            this.submitField(formField, true);
        }
    }

    submitField(element: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement, init: boolean) {
        if (this.isInit) {
            this.isInit = false;
            if (this.noInitSubmit) return;
        }

        let value: string;

        if (element instanceof HTMLInputElement && element.type === 'checkbox') {
            value = element.checked.toString();
        } else {
            value = element.value;
        }

        const data = {
            attr: this.attr || '',
            value,
        };

        this.changeTimeout = setTimeout(() => {
                fetchRequest({
                    requestURL: this.requestURL!,
                    resolveHandler: this.refreshContent.bind(this, init),
                    payload: data,
                })
            }
            ,500
        )
    }


    refreshContent(init:boolean) {
        if (init) return;
        // eslint-disable-next-line no-self-assign
        if (this.reloadAfterSubmit) return window.location.href = window.location.href;

        if (this.forceReload) {
            const container = document.querySelector('[data-tk-container]') as HTMLElement | undefined;
            const requestURL = container?.getAttribute('data-tk-content-url');

            if (!container || !requestURL) {
                location.reload();
            } else {
                this.fetchContent(container, requestURL);
            }
        }

        if (this.reloadSummary && this.summaryContainer && this.summeryURL) {
            this.fetchContent(this.summaryContainer, this.summeryURL);
        }
    }

    fetchContent(container: HTMLElement, requestURL: string) {
        fetchRequest({
            requestURL,
            resolveHandler: this.replaceContent.bind(this, container),
        });
    }

    replaceContent(container:HTMLElement, response:TKResponse):void {
        const body = render(response.dataAsHtml, true);
        container.replaceChildren(body);
        const newTotal = container.querySelector('[data-tk-checkout-total]')?.innerHTML;
        const footerTotal = document.querySelector('[data-op-asyncbasket]');
        if (!newTotal || !footerTotal) return;
        footerTotal.innerHTML = newTotal;
    }
}
